/**
 * 
 * Shader combines the cut and twist filters.
 * It cuts the vector data (displacement either horizontal or vertical)
 * Then adds a subtle curve or warp to the cut.
 *
 */

import fragment from './cutandtwist.glsl';

var CutAndTwist = function () {
    PIXI.AbstractFilter.call(this);

    this.passes = [this];

    this.uniforms = {
        //  0 - 10 the length of each cut
        // also the severity of the curve
        rand: {type: '1f', value: 0.0},
        // 0 - 500 you can leave this val at 0, unless you want to step forward the twist.
        timer: {type: '1f', value: 0},
        // space between each cut. 0 - 700
        cutval1: {type: '1f', value: 0.0},
        // the length, offset of each cut
        cutval2: {type: '1f', value: 0.0},

        twistrand: {type: '1f', value: 0.0},
        twistval1: {type: '1f', value: 0.0},
        twistval2: {type: '1f', value: 0.0},
        dimensions: {type: '4fv', value: [0, 0, 0, 0]},
        horizontal : {type: '1f' , value: 1.0 }
    };

    this.fragmentSrc = fragment;

};

CutAndTwist.prototype = Object.create(PIXI.AbstractFilter.prototype);
CutAndTwist.prototype.constructor = CutAndTwist;

Object.defineProperties(CutAndTwist.prototype, {
    rand : {
        get: function() {
            return this.uniforms.rand.value;
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.rand.value = value;
        }
    },
    twistrand : {
        get: function() {
            return this.uniforms.twistrand.value;
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.twistrand.value = value;
        }
    },
    timer : {
        get: function() {
            return this.uniforms.timer.value;
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.timer.value = value;
        }
    },
    cutval1 : {
        get: function() {
            return this.uniforms.cutval1.value;
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.cutval1.value = value;
        }
    },
    cutval2 : {
        get: function() {
            return this.uniforms.cutval2.value;
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.cutval2.value = value;
        }
    },
    twistval1 : {
        get: function() {
            return this.uniforms.twistval1.value;
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.twistval1.value = value;
        }
    },
    twistval2 : {
        get: function() {
            return this.uniforms.twistval2.value;
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.twistval2.value = value;
        }
    },
    horizontal : {
        get: function() {
            return this.uniforms.horizontal.value;
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.horizontal.value = value;
        }  
    }
});


module.exports = CutAndTwist;


/** WEBPACK FOOTER **
 ** ./src/js/views/shaders/cutandtwist.js
 **/